// Numeri che contano fino al valore: 650 ms, una volta sola, al primo caricamento della dashboard
// (pacchetto del 29-10). Mai quando cambi un filtro o un periodo. Con «riduci movimento» il numero è già
// al suo posto. Monta il componente quando il dato c'è: un valore provvisorio a 0 non consuma l'animazione.
import { useLayoutEffect, useRef, useState } from "react";

export function prefersReducedMotion() {
  if (typeof window === "undefined" || !window.matchMedia) return true;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

export function useCountUp(target, duration = 650) {
  const [value, setValue] = useState(target);
  const fatto = useRef(false);

  useLayoutEffect(() => {
    if (fatto.current || target === 0 || prefersReducedMotion() || typeof requestAnimationFrame !== "function") {
      setValue(target);
      return undefined;
    }
    let raf = 0;
    let finito = false;
    const t0 = performance.now();
    const step = (t) => {
      const p = Math.min(1, (t - t0) / duration);
      setValue(target * (1 - Math.pow(1 - p, 3))); // ease-out: parte svelto e si posa
      if (p < 1) raf = requestAnimationFrame(step);
      else {
        finito = true;
        fatto.current = true;
      }
    };
    setValue(0);
    raf = requestAnimationFrame(step);
    return () => {
      cancelAnimationFrame(raf);
      // in StrictMode React monta, smonta e rimonta: se l'animazione non è finita, si riparte
      if (!finito) setValue(target);
    };
  }, [target, duration]);

  return value;
}
